module.exports = {
    // Dev Console
    GET_DISCORD_ACCESS: "common/discord/invite/",
    DISCORD_INVITE: "https://discordapp.com/api/v9/invites/"
    // Dev Auth
    // App Management
}
